const figsIndividualEnvironments = ["test", "local", "live"];
function isFigsIndividualEnvironment(maybeFigsEnvironment) {
  return typeof maybeFigsEnvironment === "string" && figsIndividualEnvironments.includes(maybeFigsEnvironment);
}
const figsSharedEnvironments = ["sandbox", "staging", "preview", "prod"];
function isFigsSharedEnvironment(maybeFigsEnvironment) {
  return typeof maybeFigsEnvironment === "string" && figsSharedEnvironments.includes(maybeFigsEnvironment);
}
const figsEnvironments = [...figsIndividualEnvironments, ...figsSharedEnvironments];
function isFigsEnvironment(maybeFigsEnvironment) {
  return typeof maybeFigsEnvironment === "string" && figsEnvironments.includes(maybeFigsEnvironment);
}
function getFigsEnvironment() {
  const processEnvironment = process.env.FIGS_ENV || process.env.NEXT_PUBLIC_FIGS_ENV;
  return isFigsEnvironment(processEnvironment) ? processEnvironment : "local";
}

export { figsEnvironments, figsIndividualEnvironments, figsSharedEnvironments, getFigsEnvironment, isFigsEnvironment, isFigsIndividualEnvironment, isFigsSharedEnvironment };
